export default {
  name: "Team",
  metaInfo: {
    title: 'Team | Canvas Development',
    meta: [
      {
        name: 'keywords',
        content: 'team'
      },
      {
        name: 'description',
        content: 'Meet our team of hard working and flexible developers that can accommodate your needs.'
      }
    ]

  },
  data() {
    return {
      teams: [
        {
          image: "/assets/images/avatar-peyton.jpg",
          name: "Peyton",
          position: "Team Manager"
        },
        {
          image: "/assets/images/avatar-cherry.jpg",
          name: "Cherry",
          position: "Team Manager"
        },
        {
          image: "/assets/images/avatar-sawyer.jpg",
          name: "Sawyer",
          position: "Project Manager"
        },
        {
          image: "/assets/images/avatar-andrew.jpg",
          name: "Andrew",
          position: "Project Manager"
        },
        {
          image: "/assets/images/avatar-michael.jpg",
          name: "Michael",
          position: "Graphic Designer & Project Manager"
        },
        {
          image: "/assets/images/avatar-dun.jpg",
          name: "Dunn",
          position: "Full Stack Web Developer"
        },
        {
          image: "/assets/images/avatar-jim.jpg",
          name: "Jim",
          position: "Web Developer"
        },
        {
          image: "/assets/images/avatar-vic.jpg",
          name: "Vic",
          position: "Web Developer"
        },
        {
          image: "/assets/images/avatar-james.jpg",
          name: "James",
          position: "Web Developer"
        },
        {
          image: "/assets/images/avatar-sol.jpg",
          name: "Sol",
          position: "Software & Web Developer"
        },
        {
          image: "/assets/images/avatar-enrique.jpg",
          name: "Enrique",
          position: "Web Developer"
        },
        {
          image: "/assets/images/avatar-janrick.jpg",
          name: "Val",
          position: "Web Developer"
        },
        {
          image: "/assets/images/avatar-eric.jpg",
          name: "Eric",
          position: "Backend Web Developer"
        },
        {
          image: "/assets/images/avatar-rob.jpg",
          name: "Rob",
          position: "Junior Web Developer"
        }
      ]
    };
  }
};
